// extracted by mini-css-extract-plugin
export default {"wrapper":"affiliate_wrapper__uRcen"};